export type RelinkedServiceType = 'Callout' | 'Session' | 'Job'

/**
 * The server records each service moved by a customer archive as a change
 * whose field is `relinkedService[To]:<callout|session|job>:<public id>`
 * (pb_hooks/lib/customer-archive.js). Returns null for any other change.
 */
export function parseRelinkedServiceField(
  field: string,
): { serviceType: RelinkedServiceType; ref: string; direction: 'from' | 'to' } | null {
  const match = /^relinkedService(To)?:(callout|session|job):(.+)$/.exec(field)
  if (!match) return null
  const serviceType =
    match[2] === 'callout' ? 'Callout' : match[2] === 'session' ? 'Session' : 'Job'
  return { serviceType, ref: match[3], direction: match[1] ? 'to' : 'from' }
}

export const serviceDetailPaths = {
  Callout: '/callouts/$id',
  Session: '/sessions/$id',
  Job: '/jobs/$id',
} as const
